const _ = require("lodash");

/**
 * Detects platform environment and region from the current host URL.
 * This is used for browser runtime configuration detection.
 *
 * @returns {{ isChinaHost: boolean, platformEnv: string }} Host info
 */
const detectHostInfo = () => {
  const host = window.location.host || "";
  const hostLower = host.toLowerCase();

  // Determine if China host
  const isChinaHost = hostLower.includes(".cn");

  // Platform environment mapping
  const envHostMappings = [
    { host: "staging-web.toddleapp", env: "staging" },
    { host: "preprod1-web.toddleapp", env: "preprod1" },
    { host: "preprod-web.toddleapp", env: "preprod" },
    { host: "sr1-web.toddleapp", env: "sr1" },
    { host: "sr2-web.toddleapp", env: "sr2" },
    { host: "test-1-web.toddleapp", env: "test-1" },
    { host: "web.toddleapp", env: "production" },
  ];

  const matchedEnv = envHostMappings.find(({ host }) =>
    hostLower.startsWith(host)
  );

  // On localhost, allow ?env= to override the environment (used by build-verify smoke tests).
  // This has no effect on deployed environments since they always match a host above.
  const isLocalhost = hostLower === "localhost" || hostLower.startsWith("localhost:");
  const envFromUrl = isLocalhost && new URLSearchParams(window.location.search).get("env");
  const platformEnv = envFromUrl || (matchedEnv ? matchedEnv.env : "staging");

  return { isChinaHost, platformEnv };
};

const hostInfo = detectHostInfo();

const applyRegionalConfig = (baseConfig, isChinaFlag) => {
  if (!baseConfig || typeof baseConfig !== "object") {
    throw new Error("Invalid base configuration object");
  }

  const regionKey = isChinaFlag ? "china" : "global";
  const regionConfig = _.get(baseConfig, ["regional", regionKey]);

  if (!regionConfig) {
    return baseConfig;
  }

  return _.merge({}, _.omit(baseConfig, "regional"), regionConfig);
};

module.exports = {
  hostInfo,
  applyRegionalConfig,
};
